import script from "./ProductArticlesMatrixCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductArticlesMatrixCell.vue?vue&type=script&setup=true&lang=ts"

import "./ProductArticlesMatrixCell.vue?vue&type=style&index=0&id=23e00f27&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23e00f27"]])

export default __exports__